import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {PsychometricParameterType} from "../../gen/api";
import MarkdownViewer from "../Markdown/MarkdownViewer";
import PsychometricParameterTable from "./PsychometricParameterTable";

type Props = {
  psychometricParameter: PsychometricParameterType
}

export default function PsychometricParameterTableView({psychometricParameter}: Props) {

  return (
      <PsychometricParameterTable psychometricParameterName={psychometricParameter.name}
                                  edit={false}>
        {psychometricParameter.psychometricParameters?.map(parameter => (
            <TableRow key={parameter.id}
                      sx={{'&:last-child td, &:last-child th': {border: 0}}}>
              <TableCell component="th" scope="row">
                <MarkdownViewer value={parameter.parameter || ""}/>
              </TableCell>
              <TableCell>
                <MarkdownViewer value={parameter.approach || ""}/>
              </TableCell>
              <TableCell>
                <MarkdownViewer value={parameter.results || ""}/>
              </TableCell>
              <TableCell>
                <MarkdownViewer value={parameter.sample || ""}/>
              </TableCell>
            </TableRow>
        ))}
      </PsychometricParameterTable>
  );
}